import * as Ariakit from '@ariakit/react'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { SearchProps } from './search'

interface Props extends Pick<SearchProps, 'state' | 'items'> {
  children: React.ReactNode
}

function getHrefFromItem({
  value,
  items,
}: {
  value?: Ariakit.ComboboxStoreProps['selectedValue']
  items: SearchProps['items']
}) {
  const selectedItem = items?.find((item) => item.value === value)

  return selectedItem?.href
}

export function SearchNavigationWrapperInRouterContext({ state, children, items }: Props) {
  const navigate = useNavigate()
  const selectedValue = state.useState('selectedValue')
  React.useEffect(() => {
    const href = getHrefFromItem({ value: selectedValue, items })
    if (href) {
      navigate(href)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValue])

  return children
}

export function SearchNavigationWrapperOutsideRouterContext({ state, children, items }: Props) {
  const selectedValue = state.useState('selectedValue')
  React.useEffect(() => {
    const href = getHrefFromItem({ value: selectedValue, items })

    if (href) {
      window.location.href = href
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValue])

  return children
}
